import React from 'react';
import logo from '../images/inspira_solo.webp'
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const Logo = () => {
    const location = useLocation();
    const isHome = location.pathname === '/';

    return (
        <div className={`flex justify-center items-start w-full ${isHome ? 'mt-10 h-1/5' : 'mt-4'}`}>
            <motion.img
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ type: 'spring', stiffness: 70 }} 
                src={logo} 
                alt="Logo" 
                className={
                    isHome 
                        ? "h-14 w-auto md:h-20 lg:h-28" 
                        : "h-6 w-auto md:h-8 lg:h-10"
                } 
            />
        </div>
    );
};

export default Logo;
